/**
 * A phone number and an email address you can act on (#340, web half).
 *
 * MOBILE HAS HAD THIS SINCE #340 AND WEB HAD NOTHING. Vendor contact
 * details are captured on the create form on both platforms and were
 * displayed on neither web screen -- so somebody could type a shop's
 * number into the app and then have no way to read it back. The phone
 * showed it in two places; the desk showed it nowhere.
 *
 * Found by asking what the deleted ClientsPage used to show (#418).
 * The answer was that it never showed contact details either -- they were
 * only ever on its create form -- so this is not a regression, it is a
 * gap that had simply never been noticed on this platform. #325 exists
 * because a rule living on one platform is half a rule.
 *
 * BOTH ARE SHOWN WHEN BOTH EXIST, which is mobile's hard-won wording:
 * the clients list there once rendered `phone || email`, so the one
 * contact detail somebody had was the one they could not see.
 *
 * NO CONFIRMATION, unlike mobile, and that is a considered difference
 * rather than an omission. Mobile confirms because these sit in a list
 * tapped with gloves on and a mis-tap places a real call to a customer.
 * A mouse click on a link is not a mis-tap, and `tel:` on a desktop
 * usually opens a dialogue of its own anyway -- adding a second one
 * would be asking twice.
 *
 * Plain links rather than buttons: a phone number IS a link, it should
 * copy, open in a new tab and right-click like one, and it should be
 * readable as text by somebody who just wants to write it down.
 */
export function ContactLinks({ phone, email, className = "" }) {
  if (!phone && !email) return null;

  return (
    <p className={className} style={{ display: "flex", gap: "var(--space-3)", flexWrap: "wrap", margin: 0 }}>
      {phone && (
        <a href={`tel:${phone.replace(/[^\d+]/g, "")}`}>
          {/* The number as typed, not as normalised. The href strips
              spaces and punctuation so the dialer gets something it can
              use; the text keeps whatever the user wrote, because that is
              the form they will recognise. */}
          📞 {phone}
        </a>
      )}
      {email && <a href={`mailto:${email}`}>✉️ {email}</a>}
    </p>
  );
}
